"use client";

import type {VariantProps} from "@gluestack-ui/nativewind-utils";
import {tva} from "@gluestack-ui/nativewind-utils/tva";
import React from "react";
import {Platform, View} from "react-native";

const dividerStyle = tva({
    base: "bg-blueGray-200",
    variants: {
        orientation: {
            vertical: "w-1 md:w-px h-full",
            horizontal: "h-1 md:h-px w-full"
        }
    }
});

type IUIDividerProps = React.ComponentPropsWithoutRef<typeof View> &
    VariantProps<typeof dividerStyle>;

const Divider = React.forwardRef<React.ElementRef<typeof View>, IUIDividerProps>(
    ({className, orientation = "horizontal", ...props}, ref) => {
        return (
            <View
                ref={ref}
                {...props}
                aria-orientation={orientation}
                className={dividerStyle({
                    orientation,
                    class: className
                })}
                role={Platform.OS === "web" ? "separator" : undefined}
            />
        );
    }
);

Divider.displayName = "Divider";

export {Divider};
